import { render, staticRenderFns } from "./CreditAssignmentProductSearchParametersEditor.vue?vue&type=template&id=23a0a479&"
import script from "./CreditAssignmentProductSearchParametersEditor.vue?vue&type=script&lang=js&"
export * from "./CreditAssignmentProductSearchParametersEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports